import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { AlertCircle, CheckCircle, Info, XCircle, X } from 'lucide-react';
import { cn } from '../../lib/utils';
const alertVariants = cva('relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground border-l-4', {
  variants: {
    variant: {
      default: 'bg-[#1A1A2E] text-foreground border-gray-700 border-l-gray-500',
      info: 'bg-[#1A1A2E] text-white border-primary/20 border-l-primary [&>svg]:text-primary',
      success: 'bg-[#1A1A2E] text-white border-accent/20 border-l-accent [&>svg]:text-accent',
      warning: 'bg-[#1A1A2E] text-white border-[#FF9900]/20 border-l-[#FF9900] [&>svg]:text-[#FF9900]',
      destructive: 'bg-[#1A1A2E] text-white border-[#FF1744]/20 border-l-[#FF1744] [&>svg]:text-[#FF1744]'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
interface AlertProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof alertVariants> {
  title?: string;
  onDismiss?: () => void;
}
export function Alert({
  className,
  variant,
  title,
  children,
  onDismiss,
  ...props
}: AlertProps) {
  const Icon = {
    default: Info,
    info: Info,
    success: CheckCircle,
    warning: AlertCircle,
    destructive: XCircle
  }[variant || 'default'];
  return <div role="alert" className={cn(alertVariants({
    variant
  }), className)} {...props} data-id="element-320">
      <Icon className="h-5 w-5" data-id="element-321" />
      <div className="flex justify-between items-start gap-4" data-id="element-322">
        <div className="w-full" data-id="element-323">
          {title && <h5 className="mb-1 font-medium leading-none tracking-tight" data-id="element-324">
              {title}
            </h5>}
          <div className="text-sm opacity-90" data-id="element-325">{children}</div>
        </div>
        {onDismiss && <button onClick={onDismiss} className="text-gray-400 hover:text-white transition-colors" data-id="element-326">
            <X className="h-4 w-4" data-id="element-327" />
            <span className="sr-only" data-id="element-328">Dismiss</span>
          </button>}
      </div>
    </div>;
}